export const environment = {
  production: false,
  inBrowser: false,
  name: 'preprod',
  aem: '', // host AEM
  api: 'https://dxl.vodafone.it', // host API
  apiKeycloak: 'https://keycloak.dxl.vodafone.it',
  apiBasePath: 'api-biz-bs',
  resource: '/etc.clientlibs/myvf-business/clientlibs/myvf-business-webview/resources',
  apiAWS: 'https://business.api.mvacloud.vodafone.it/prod/bs',
  aemBasePath:'https://mva-business-bs.vodafone.it',
  apiProcessFlow: 'https://eks.webcloud.vodafone.it/dxl/prod'
};
